import { NavLink, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';

const navItems: Array<{
  to: string;
  label: string;
  icon: string;
  auth?: boolean;
}> = [
  { to: '/', label: 'Home', icon: '🏠' },
  { to: '/rooms', label: 'Rooms', icon: '📺', auth: true },
  { to: '/join', label: 'Join', icon: '🔗', auth: true },
  { to: '/settings', label: 'Settings', icon: '⚙️', auth: true },
];

export function MobileNav() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  const items = navItems.filter((item) => !item.auth || isAuthenticated);

  if (items.length === 0) return null;

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 glass border-t border-white/10 sm:hidden safe-area-pb"
      aria-label="Mobile navigation"
    >
      <div className="flex items-center justify-around h-14">
        {items.map((item) => {
          const active =
            item.to === '/'
              ? location.pathname === '/'
              : location.pathname.startsWith(item.to);

          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors ${
                active ? 'text-brand-400' : 'text-surface-500'
              }`}
            >
              <span className="text-lg leading-none">{item.icon}</span>
              <span className="text-[10px] font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
